import { Route } from '@angular/router';
import { StatusProjectComponent } from '@projects';

export const appRoutes: Route[] = [
  {
    path: '',
    title: 'Status',
    component: StatusProjectComponent
  }
];
